import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, motion } from '../tokens';

const DEFAULT_CHIPS = [
  { id: 'all',       label: 'All' },
  { id: 'gift',      label: 'Gifts' },
  { id: 'email',     label: 'Email' },
  { id: 'call',      label: 'Calls' },
  { id: 'task',      label: 'Tasks' },
  { id: 'note',      label: 'Notes' },
  { id: 'event',     label: 'Events' },
  { id: 'volunteer', label: 'Volunteer' },
];

const TimelineFilterChips = ({
  chips = DEFAULT_CHIPS,
  active = ['all'],
  onChange,
  showSystemToggle = true,
  systemVisible = false,
  onToggleSystem,
  counts = {},
}) => {
  const toggle = (id) => {
    if (!onChange) return;
    if (id === 'all') return onChange(['all']);
    let next = active.filter(a => a !== 'all');
    if (next.includes(id)) next = next.filter(a => a !== id);
    else next = [...next, id];
    if (next.length === 0) next = ['all'];
    onChange(next);
  };

  const isActive = (id) => active.includes(id) || (active.includes('all') && id === 'all');

  return (
    <div style={{
      display: 'flex',
      gap: space[2],
      alignItems: 'center',
      flexWrap: 'wrap',
      paddingBottom: space[3],
      borderBottom: `1px solid ${colors.border}`,
      marginBottom: space[3],
    }}>
      {chips.map(chip => {
        const on = isActive(chip.id);
        const count = counts[chip.id];
        return (
          <button
            key={chip.id}
            onClick={() => toggle(chip.id)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: `4px 12px`,
              background: on ? colors.brand : colors.surface,
              color: on ? '#fff' : colors.textSecondary,
              border: `1px solid ${on ? colors.brand : colors.border}`,
              borderRadius: radius.pill,
              ...type.small,
              fontWeight: 600,
              fontFamily: 'inherit',
              cursor: 'pointer',
              transition: `all ${motion.fast}`,
              whiteSpace: 'nowrap',
            }}
          >
            {chip.label}
            {count != null && (
              <span style={{
                ...type.micro,
                padding: '1px 6px',
                borderRadius: radius.pill,
                background: on ? 'rgba(255,255,255,0.22)' : colors.surfaceInk,
                color: on ? '#fff' : colors.textTertiary,
                fontWeight: 600,
              }}>
                {count}
              </span>
            )}
          </button>
        );
      })}

      {showSystemToggle && (
        <button
          onClick={onToggleSystem}
          title={systemVisible ? 'Hide system events' : 'Show system events'}
          style={{
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            padding: `4px 10px`,
            background: 'transparent',
            color: colors.textTertiary,
            border: `1px solid ${colors.border}`,
            borderRadius: radius.pill,
            ...type.micro,
            fontFamily: 'inherit',
            cursor: 'pointer',
            transition: `all ${motion.fast}`,
          }}
        >
          <Icon
            category="utility"
            name={systemVisible ? 'preview' : 'hide'}
            size="xx-small"
            style={{ fill: colors.textTertiary }}
          />
          System events {systemVisible ? '✓' : ''}
        </button>
      )}
    </div>
  );
};

export default TimelineFilterChips;
